import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import StructuredData from './StructuredData'
import { optimizelyExperimentID } from '../helpers/constants'

function SEO({ metaData, noIndexNoFollow }) {
  const optimizelyScript = `https://cdn.optimizely.com/js/${optimizelyExperimentID}.js`
  return (
    <StaticQuery
      query={graphql`
        query SiteMetadataQuery {
          contentfulSeoMetadata {
            descriptionMetadata {
              aboutUs
              accessibility
              affiliate
              creditCard
              debtConsolidation
              emergencyLoan
              generic
              home
              homeImprovement
              personalLoans
              privacyNotices
              privacyPolicy
              sms
              termsOfUse
              securedPersonalLoans
              autoTitleLoans
              licensure
              avantCardOffer
              cardHolderBenefits
              cardMemberAgreement
              sitemap
            }
            titleMetadata {
              aboutUs
              accessibility
              affiliate
              creditCard
              debtConsolidation
              emergencyLoan
              generic
              home
              homeImprovement
              termsOfUse
              sms
              privacyPolicy
              privacyNotices
              personalLoans
              securedPersonalLoans
              autoTitleLoans
              licensure
              avantCardOffer
              cardHolderBenefits
              cardMemberAgreement
              sitemap
            }
          }
        }
      `}
      render={data => (
        <Helmet
          title={data.contentfulSeoMetadata.titleMetadata[metaData]}
          meta={[
            {
              name: 'description',
              content: data.contentfulSeoMetadata.descriptionMetadata[metaData]
            },
            { name: 'keywords', content: '' },
            noIndexNoFollow ? { name: 'robots', content: 'noindex, nofollow' } : {}
          ]}
        >
          <script src={optimizelyScript} />
          {noIndexNoFollow ? null : (
            <link
              rel="canonical"
              href={
                typeof window !== 'undefined'
                  ? window.location.origin + window.location.pathname
                  : null
              }
            />
          )}
          <html lang="en" />
          {typeof window !== 'undefined' && window.location.pathname === '/' ? (
            <script type="application/ld+json">{JSON.stringify(StructuredData.homepage)}</script>
          ) : null}
          {typeof window !== 'undefined' && window.location.pathname === '/personal-loans/' ? (
            <script type="application/ld+json">
              {JSON.stringify(StructuredData.personalLoans)}
            </script>
          ) : null}
        </Helmet>
      )}
    />
  )
}

SEO.propTypes = {
  metaData: PropTypes.string.isRequired,
  noIndexNoFollow: PropTypes.bool
}

SEO.defaultProps = {
  noIndexNoFollow: false
}

export default SEO
